import React from "react";
import styles from "./Footer.module.scss";
import Modal from "../../UI/Modal/Modal";
import { Link } from "react-router";
import { SELLER } from "../../../config/legal";

const Footer: React.FC = () => {
  const [isRegAuthModalActive, setIsRegAuthModalActive] = React.useState(false);

  return (
    <footer className={styles.footer}>
      <div className="container">
        <Modal mode="authReg" isActive={isRegAuthModalActive} setIsActive={setIsRegAuthModalActive} />
        <div className={styles.body}>
          <ul className={styles.list}>
            <div className={styles.title}>
              <h2 className="animated-underline">Ткани</h2>
            </div>
            <div className={styles.row}>
              <div className={styles.part}>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Бельевые</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Блузочные</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Верхняя одежда</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Вечерние</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Детские</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Для дома</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Костюмные</Link>
                  </p>
                </li>
              </div>
              <div className={styles.part}>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Плательные</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Подкладочные</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Рубашечные</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Спортивные</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Сценарические</Link>
                  </p>
                </li>
                <li className={styles.item}>
                  <p className="animated-underline">
                    <Link to="/catalog">Эксклюзивные</Link>
                  </p>
                </li>
                <div className={styles.link}>
                  <p className="animated-underline">
                    <Link to="/catalog">Перейти в каталог</Link>
                  </p>
                </div>
              </div>
            </div>
          </ul>
          <ul className={styles.list}>
            <div className={styles.title}>
              <h2 className="animated-underline">Фурнитура</h2>
            </div>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/catalog">Карабины</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/catalog">Перья и Боа</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/catalog">Булавки</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/catalog">Декоры для одежды</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/catalog">Клеевые материалы</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/catalog">Кнопки</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/catalog">Косая бейка</Link>
              </p>
            </li>
            <div className={styles.link}>
              <p className="animated-underline">
                <Link to="/catalog">Перейти в каталог</Link>
              </p>
            </div>
          </ul>
          <ul className={styles.list}>
            <div className={styles.title}>
              <h2>Покупателям</h2>
            </div>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/delivery-and-payment">Доставка и оплата</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/schemas">Выкройки и схемы</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/gifts">Подарочные сертификаты</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="goods-return">Условия возврата</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/cart">Корзина</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="sample-questionnare">Анкета для предоставления образцов</Link>
              </p>
            </li>

            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="young-designers">Анкета для молодых дизайнеров</Link>
              </p>
            </li>
            <ul className={`${styles.list} ${styles.specList}`}>
              <div className={styles.title}>
                <h2>Ткани оптом</h2>
              </div>
              <li className={styles.item}>
                <p className="animated-underline">
                  <Link to="/catalog">Китай</Link>
                </p>
              </li>
              <li className={styles.item}>
                <p className="animated-underline">
                  <Link to="/catalog">Турция</Link>
                </p>
              </li>
              <li className={styles.item}>
                <p className="animated-underline">
                  <Link to="/catalog">Крупный опт</Link>
                </p>
              </li>
            </ul>
          </ul>
          <ul className={styles.list}>
            <div className={styles.title}>
              <h2 className="animated-underline">Магазин</h2>
            </div>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/contacts">Контакты</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/about-us">О нас</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/vacancies">Вакансии</Link>
              </p>
            </li>
            <li className={styles.item}>
              <p className="animated-underline">
                <Link to="/sales-and-news">Акции и новости</Link>
              </p>
            </li>
            <ul className={styles.info}>
              <li className={styles.item}></li>
              <li className={styles.item}></li>
              <li className={styles.item}></li>
            </ul>
          </ul>
        </div>
        <div className={styles.author}>
          <div className={styles.runa} itemScope itemType="https://schema.org/Organization">
            <div className={styles.image}>
              <img src="/img/footer/logo.svg" alt="Тканополис" itemProp="logo" />
            </div>
            <p>
              <span itemProp="name">{SELLER.name}</span>
              <br />
              <span itemProp="taxID">ИНН {SELLER.inn}</span>
              <br />
              <span itemProp="identifier">ОГРНИП {SELLER.ogrnip}</span>
            </p>
          </div>
          <div className={styles.policy}>
            <h2 className={`${styles.title} animated-underline`}>
              <Link to="/policy">Политика обработки персональных данных</Link>
            </h2>
            <h2 className={`${styles.title} animated-underline`}>
              <Link to="/privacy">Политика конфиденциальности</Link>
            </h2>
            <h2 className={`${styles.title} animated-underline`}>
              <a href="/documents/oferta.pdf" target="_blank" rel="noopener noreferrer">
                Оферта
              </a>
            </h2>
          </div>
          <div className={styles.payment}>
            <img src="/img/footer/payment.svg" alt="payment" />
          </div>
        </div>
        <nav className={styles.menu}>
          <ul className={styles.list}>
            <Link to="/" className={`${styles.item} ${styles.current}`}>
              <svg viewBox="0 0 61 61" fill="currentColor">
                <path
                  d="M60.135 31.5068L32.76 1.09013C31.6072 -0.193454 29.3928 -0.193454 28.24 1.09013L0.865047 31.5068C0.471701 31.944 0.213513 32.4858 0.121741 33.0666C0.0299684 33.6475 0.108547 34.2425 0.347964 34.7796C0.83463 35.8777 1.92355 36.5833 3.12501 36.5833H9.20834V57.875C9.20834 58.6817 9.5288 59.4554 10.0992 60.0258C10.6696 60.5962 11.4433 60.9167 12.25 60.9167H21.375C22.1817 60.9167 22.9554 60.5962 23.5258 60.0258C24.0962 59.4554 24.4167 58.6817 24.4167 57.875V45.7083H36.5833V57.875C36.5833 58.6817 36.9038 59.4554 37.4742 60.0258C38.0446 60.5962 38.8183 60.9167 39.625 60.9167H48.75C49.5567 60.9167 50.3304 60.5962 50.9008 60.0258C51.4712 59.4554 51.7917 58.6817 51.7917 57.875V36.5833H57.875C58.4641 36.5858 59.0411 36.4169 59.5359 36.0971C60.0306 35.7773 60.4216 35.3205 60.6611 34.7823C60.9007 34.2442 60.9785 33.648 60.8851 33.0663C60.7917 32.4847 60.531 31.9428 60.135 31.5068Z"
                  fill="currentColor"
                />
              </svg>
              <p>Главная</p>
            </Link>
            <Link to="/catalog" className={`${styles.item}`}>
              <svg viewBox="0 0 59 59" fill="currentColor">
                <path
                  d="M21.125 1.58337H4.37501C3.63461 1.58337 2.92454 1.8775 2.401 2.40103C1.87746 2.92457 1.58334 3.63464 1.58334 4.37504V21.125C1.58334 21.8654 1.87746 22.5755 2.401 23.099C2.92454 23.6226 3.63461 23.9167 4.37501 23.9167H21.125C21.8654 23.9167 22.5755 23.6226 23.099 23.099C23.6226 22.5755 23.9167 21.8654 23.9167 21.125V4.37504C23.9167 3.63464 23.6226 2.92457 23.099 2.40103C22.5755 1.8775 21.8654 1.58337 21.125 1.58337ZM21.125 35.0834H4.37501C3.63461 35.0834 2.92454 35.3775 2.401 35.901C1.87746 36.4246 1.58334 37.1346 1.58334 37.875V54.625C1.58334 55.3654 1.87746 56.0755 2.401 56.599C2.92454 57.1226 3.63461 57.4167 4.37501 57.4167H21.125C21.8654 57.4167 22.5755 57.1226 23.099 56.599C23.6226 56.0755 23.9167 55.3654 23.9167 54.625V37.875C23.9167 37.1346 23.6226 36.4246 23.099 35.901C22.5755 35.3775 21.8654 35.0834 21.125 35.0834ZM54.625 1.58337H37.875C37.1346 1.58337 36.4245 1.8775 35.901 2.40103C35.3775 2.92457 35.0833 3.63464 35.0833 4.37504V21.125C35.0833 21.8654 35.3775 22.5755 35.901 23.099C36.4245 23.6226 37.1346 23.9167 37.875 23.9167H54.625C55.3654 23.9167 56.0755 23.6226 56.599 23.099C57.1226 22.5755 57.4167 21.8654 57.4167 21.125V4.37504C57.4167 3.63464 57.1226 2.92457 56.599 2.40103C56.0755 1.8775 55.3654 1.58337 54.625 1.58337Z"
                  fill="currentColor"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
                <path
                  d="M35.0833 35.0834H57.4167M46.25 46.25H57.4167M35.0833 57.4167H57.4167"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>Каталог</p>
            </Link>
            <li className={`${styles.item}`}>
              <svg viewBox="0 0 65 65" fill="currentColor">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 32.5C0 23.8805 3.4241 15.614 9.51903 9.51903C15.614 3.4241 23.8805 0 32.5 0C41.1195 0 49.386 3.4241 55.481 9.51903C61.5759 15.614 65 23.8805 65 32.5C65 41.1195 61.5759 49.386 55.481 55.481C49.386 61.5759 41.1195 65 32.5 65C23.8805 65 15.614 61.5759 9.51903 55.481C3.4241 49.386 0 41.1195 0 32.5ZM30.3333 17.3333C28.2874 17.3331 26.2702 17.8157 24.4459 18.742C22.6217 19.6684 21.0418 21.0122 19.8348 22.6642C18.6278 24.3162 17.8278 26.2298 17.4998 28.2493C17.1718 30.2688 17.3251 32.3372 17.9473 34.2863C18.5694 36.2354 19.6428 38.0102 21.0801 39.4662C22.5175 40.9222 24.2782 42.0184 26.2191 42.6657C28.16 43.3129 30.2263 43.4929 32.2499 43.191C34.2734 42.8891 36.1972 42.1139 37.8647 40.9283L43.9703 47.034L47.034 43.9703L40.9283 37.8647C42.3106 35.9199 43.1309 33.6323 43.2996 31.2524C43.4683 28.8725 42.9788 26.492 41.8846 24.3718C40.7905 22.2515 39.134 20.4733 37.0965 19.2318C35.0591 17.9904 32.7192 17.3336 30.3333 17.3333Z"
                  fill="currentColor"
                />
              </svg>

              <p>Поиск</p>
            </li>
            <li className={`${styles.item}`} onClick={() => setIsRegAuthModalActive(true)}>
              <svg viewBox="0 0 72 72" fill="currentColor">
                <path
                  d="M49.5 27C49.5 30.5804 48.0777 34.0142 45.5459 36.5459C43.0142 39.0777 39.5804 40.5 36 40.5C32.4196 40.5 28.9858 39.0777 26.4541 36.5459C23.9223 34.0142 22.5 30.5804 22.5 27C22.5 23.4196 23.9223 19.9858 26.4541 17.4541C28.9858 14.9223 32.4196 13.5 36 13.5C39.5804 13.5 43.0142 14.9223 45.5459 17.4541C48.0777 19.9858 49.5 23.4196 49.5 27Z"
                  fill="currentColor"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 36C0 26.4522 3.79285 17.2955 10.5442 10.5442C17.2955 3.79285 26.4522 0 36 0C45.5478 0 54.7045 3.79285 61.4558 10.5442C68.2072 17.2955 72 26.4522 72 36C72 45.5478 68.2072 54.7045 61.4558 61.4558C54.7045 68.2072 45.5478 72 36 72C26.4522 72 17.2955 68.2072 10.5442 61.4558C3.79285 54.7045 0 45.5478 0 36ZM36 4.5C30.068 4.50032 24.2566 6.17563 19.2348 9.33313C14.213 12.4906 10.1848 17.0019 7.61384 22.3479C5.0429 27.6938 4.03374 33.657 4.70249 39.5512C5.37125 45.4454 7.69074 51.0309 11.394 55.665C14.589 50.517 21.6225 45 36 45C50.3775 45 57.4065 50.5125 60.606 55.665C64.3093 51.0309 66.6288 45.4454 67.2975 39.5512C67.9663 33.657 66.9571 27.6938 64.3862 22.3479C61.8152 17.0019 57.787 12.4906 52.7652 9.33313C47.7434 6.17563 41.932 4.50032 36 4.5Z"
                  fill="currentColor"
                />
              </svg>
              <p>Войти</p>
            </li>
            <li className={`${styles.item}`}>
              <svg viewBox="0 0 70 69" fill="currentColor">
                <path
                  d="M35 0.75C54.3305 0.75 70 15.8599 70 34.5C70 53.1401 54.3305 68.25 35 68.25C15.6695 68.25 0 53.1401 0 34.5C0 15.8599 15.6695 0.75 35 0.75ZM35 48C34.0717 48 33.1815 48.3556 32.5251 48.9885C31.8687 49.6214 31.5 50.4799 31.5 51.375C31.5 52.2701 31.8687 53.1285 32.5251 53.7615C33.1815 54.3944 34.0717 54.75 35 54.75C35.9283 54.75 36.8185 54.3944 37.4749 53.7615C38.1312 53.1285 38.5 52.2701 38.5 51.375C38.5 50.4799 38.1312 49.6214 37.4749 48.9885C36.8185 48.3556 35.9283 48 35 48ZM35 15.9375C31.6351 15.9375 28.408 17.2265 26.0286 19.5209C23.6492 21.8153 22.3125 24.9271 22.3125 28.1719C22.3125 29.067 22.6812 29.9254 23.3376 30.5584C23.994 31.1913 24.8842 31.5469 25.8125 31.5469C26.7408 31.5469 27.631 31.1913 28.2874 30.5584C28.9438 29.9254 29.3125 29.067 29.3125 28.1719C29.3137 27.1764 29.5958 26.1999 30.1286 25.3473C30.6615 24.4946 31.425 23.7979 32.3372 23.3319C33.2495 22.8658 34.276 22.6479 35.3069 22.7016C36.3378 22.7554 37.334 23.0786 38.1889 23.6368C39.0437 24.195 39.7249 24.967 40.1593 25.87C40.5938 26.7731 40.7652 27.7731 40.6551 28.763C40.5449 29.7528 40.1575 30.695 39.5343 31.4887C38.9111 32.2824 38.0757 32.8975 37.1175 33.2681C34.7515 34.1794 31.5 36.5149 31.5 40.4062V41.25C31.5 42.1451 31.8687 43.0035 32.5251 43.6365C33.1815 44.2694 34.0717 44.625 35 44.625C35.9283 44.625 36.8185 44.2694 37.4749 43.6365C38.1312 43.0035 38.5 42.1451 38.5 41.25C38.5 40.4265 38.675 40.0147 39.4135 39.6637L39.718 39.5287C42.4508 38.4686 44.7162 36.5248 46.1256 34.0306C47.535 31.5363 48.0007 28.647 47.4429 25.8579C46.8851 23.0688 45.3386 20.5537 43.0684 18.7437C40.7981 16.9337 37.9457 15.9416 35 15.9375Z"
                  fill="currentColor"
                />
              </svg>
              <p>Помощь</p>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
